module.exports = __webpack_public_path__ + "static/mesh-bg-full-ddac1d421b68f99253a0f3bae39b90b0.png";